<template>
	<v-tab-item>
		<h3 class="text-h6 font-weight-bold">顧客・配達情報</h3>
		<v-card flat>
			<template v-if="order_individual_info && order_individual_info.delivery_info">
				<table width="100%" class="show-dialog-table mt-2">
					<tbody>
						<ShowDetailRecord
							:columnName="'郵便番号'"
							:value="order_individual_info.delivery_info.zipcode"
						/>
						<ShowDetailRecord
							:columnName="'住所'"
							:value="order_individual_info.delivery_info.address"
							text
						/>
						<ShowDetailRecord
							:columnName="'電話番号'"
							:value="order_individual_info.delivery_info.phone"
						/>
						<ShowDetailRecord :columnName="'FAX'" :value="order_individual_info.delivery_info.fax" />
						<ShowDetailRecord
							:columnName="'企業名'"
							:value="order_individual_info.delivery_info.company_name"
						/>
						<ShowDetailRecord
							:columnName="'担当者名'"
							:value="order_individual_info.delivery_info.person_name"
						/>
					</tbody>
				</table>
			</template>
			<template v-else>
				<p class="text-body-2">配達情報はありません。</p>
			</template>
		</v-card>
	</v-tab-item>
</template>

<script>
import ShowDetailRecord from "../../shared/ShowDetailRecord.vue"
export default {
	props: {
		order_individual_info: {
			type: null,
			required: true,
		},
	},
	components: {
		ShowDetailRecord,
	},
	data() {
		return {}
	},
	methods: {},
	computed: {},
	watch: {
		order_individual_info(newVal) {
			this.order_individual_info = newVal
		},
		deep: true,
	},
}
</script>

<style>
</style>